import script from "./DebitCreditDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./DebitCreditDisplay.vue?vue&type=script&setup=true&lang=js"

import "./DebitCreditDisplay.vue?vue&type=style&index=0&id=34eb649d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34eb649d"]])

export default __exports__